import React, { FunctionComponent } from 'react';

import { connect, useSelector } from 'react-redux';

import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import BotIcon from '@components/basics/icons/bot';
import TitleWithHelper from '@components/title-w-helper';
import MetricIndicator from '@components/dashboard/metrics-widget/metric-indicator';
import ComingSoonPill from '@components/basics/coming-soon-pill';

interface ArtificialStreamsBoxProps {
  className?: string;
  isMobile: boolean;
  isComingSoon?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const ArtificialStreamsBox: FunctionComponent<ArtificialStreamsBoxProps> = ({
  className,
  isMobile,
  isComingSoon,
}) => {
  const [days, range] = useSelector((state: AppState) => {
    return [
      state.artistAnalytics.filters?.days as string,
      state.artistAnalytics.filters?.range as string,
    ];
  });
  return (
    <Box className={className || ''} noBorder>
      <Flex
        className="artificial-streams-wrapper"
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent={isMobile ? 'flex-start' : 'space-between'}
        alignItems={isMobile ? 'flex-start' : 'center'}
        gap={10}
      >
        <Flex justifyContent="flex-start" alignItems="center" gap={10}>
          <BotIcon isGrey={isComingSoon} />
          <TitleWithHelper
            small
            typographyType={undefined}
            id="artificialStreams"
            isGrey={isComingSoon}
            title={<Translate id="ANALYTICS.ENGAGEMENT.ARTIFICIAL.TITLE" />}
            helperText={
              <Translate id="ANALYTICS.ENGAGEMENT.ARTIFICIAL.TITLE.HELPER" />
            }
            subtitle={
              range === 'allTime' ? (
                <Translate id="ANALYTICS.TIMEFRAME.ALL_TIME" />
              ) : (
                <Translate
                  id="ANALYTICS.TIMEFRAME.LAST_30_DAYS"
                  data={{ days: days }}
                />
              )
            }
          />
        </Flex>
        {isComingSoon ? (
          <ComingSoonPill />
        ) : (
          <MetricIndicator
            isRed
            isGrey
            label={120752} // TODO: DEVTEAM-405 - This is demo data only. We need to use real data.
            labelFormat="none"
            value={4} // TODO: DEVTEAM-405 - This is demo data only. We need to use real data.
            valueFormat="percentage"
          />
        )}
      </Flex>
    </Box>
  );
};

export default connect(mapStateToProps)(styled(ArtificialStreamsBox)`
  padding-block: 20px;

  .artificial-streams-wrapper {
    width: 100%;
  }
`);
